<template>
  <div class="place-tag-buttons hide-scrollbar">
    <div
      v-for="placeTag in placeTags"
      :key="placeTag.name"
      class="place-tag-button"
      :class="!!placeTag.active ? 'place-tag-button-active' : (placeTag.name === '__namtang_tc' ? 'place-tag-button-gradient-border' : '')"
      @click="toggleTag(placeTag)"
    >
      <img
        height="12"
        :src="`${api_url}/${placeTag.imageUrlHD}`"
        :class="!!placeTag.active ? 'img-white' : ''"
      >
      <span>{{ $i18n.locale === 'th' ? placeTag.detail_th : placeTag.detail_en }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlaceTagButtons',
  props: {
    isDesktop: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      api_url: process.env.API_URL,
      placeTags: [],
      isLoading: false
    };
  },
  mounted () {
    this.getTagButtons()
  },
  methods: {
    toggleTag(placeTag) {
      placeTag.active = !placeTag.active
      this.$emit('on-tag-toggle', placeTag)
    },
    // ajax
    getTagButtons () {
      const scope = this
      scope.isLoading = true

      // WS-120
      var url = process.env.API_URL + '/front/tagbuttons?platform=web'
      scope.axios.get(url)
        .then(response => {
          if (response.status == 200 && response.data.code == 200) {
            for (var i in response.data.data) {
              response.data.data[i].active = false
            }
            scope.placeTags = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        }).finally(function () {
          scope.isLoading = false
        })
    },
  }
}
</script>

<style lang="scss" scoped>
.place-tag-buttons {
  width: 100%;
  position: absolute;
  top: 66px;
  padding: 6px 12px;
  overflow-x: auto;
  display: flex;
  &.place-tag-buttons-desktop {
    width: auto;
    left: 374px;
    top: 94px;
    .place-tag-button {
      margin-right: 8px;
    }
  }
  .place-tag-button {
    display: flex;
    align-items: center;
    box-shadow: 0px 0px 6px 0px #0000004D;
    border: none;
    border-radius: 8px;
    background: white;
    border: 3px solid transparent;
    padding: 4px;
    margin-right: 4px;
    flex-shrink: 0;
    cursor: pointer;
    &.place-tag-button-gradient-border {
      background-image: linear-gradient(white, white), linear-gradient(136.02deg, #5DF0CD 14.43%, #1A60E8 53.32%);
      background-origin: border-box;
      background-clip: padding-box, border-box;
    }
    &.place-tag-button-active {
      color: white;
      background: #4D82E9;
      border-color: #4D82E9;
    }
    img {
      margin-right: 6px;
    }
    span {
      user-select: none;
    }
  }
}
</style>
